import { QuickLinkColumnData } from 'design-system/shared/models/app-data-model';
import './QuickLinkColumn.scss';

import React from 'react';
import { getContentHubDamAsset } from '../../../../shared/utils/get-contenthub-dam-asset';
import PhLink from 'design-system/shared/components/ph-link/ph-link';

export type QuickLinkColumnProps = {
  quickLinkColumn: QuickLinkColumnData;
};

const QuickLinkColumn: React.FC<QuickLinkColumnProps> = ({ quickLinkColumn }: QuickLinkColumnProps) => {
  return <div className={`quick-link-column ${quickLinkColumn.highlight ? 'highlight' : ''}`}>
    {quickLinkColumn.header_link && quickLinkColumn.header_link[0]?.url ? <PhLink href={quickLinkColumn.header_link[0]?.url} className='ph-typography-link'><p><strong>{quickLinkColumn.header}</strong></p></PhLink> : <p className='header'>{quickLinkColumn.header}</p>}
    <div className='description'>{quickLinkColumn.description}</div>
    {quickLinkColumn.group.map((link, index) => {
      return (
        <PhLink
          key={index}
          href={link.reference[0]?.url || getContentHubDamAsset(link.reference[0]?.contenthub_asset)?.url|| '/'}
          className='text'
        >{link.title}</PhLink>
      );
    }
    )}
  </div>;
};

export default QuickLinkColumn;
